export default __webpack_public_path__ + "static/char-v-61-176b0026f6102742e330bd3a350c7166.png";